(function(angular){
    'use strict';

    angular.module('nucleus.widgets').directive('clientInfoWidget', clientInfoWidget);
    clientInfoWidget.$inject = [];

    function clientInfoWidget(){
        return {
            restrict: 'EA',
            templateUrl: 'dashboard/widgets/client-info/client-info-widget.2js.html',
            scope: {
                widgetData: '='
            },
            link: function(scope){
                // TODO: HOW TO LOAD IMAGE DATA
                scope.widgetData.data.userImage = undefined;
                scope.userInitials = angular.isUndefined(scope.widgetData.data.userImage) ? getUserInitials(scope.widgetData.data.primaryContactExpanded) : undefined;
            }
        };

        function getUserInitials(userData){
            var initials = [];

            if (angular.isDefined(userData.givenName) &&  userData.givenName !== '') {
                initials.push(userData.givenName.charAt(0));
            }

            if (angular.isDefined(userData.familyName) &&  userData.familyName !== '') {
                initials.push(userData.familyName.charAt(0));
            }

            if(initials.length === 0){
                initials.push(userData.fullName.charAt(0));
            }

            return initials.join('').toUpperCase();
        }
    }
})(window.angular);
